import { render, staticRenderFns } from "./PreparedContentsToolbar.vue?vue&type=template&id=84c2dbc6&scoped=true"
import script from "./PreparedContentsToolbar.vue?vue&type=script&lang=js"
export * from "./PreparedContentsToolbar.vue?vue&type=script&lang=js"
import style0 from "./PreparedContentsToolbar.vue?vue&type=style&index=0&id=84c2dbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c2dbc6",
  null
  
)

export default component.exports